import React from 'react';
import { FormattedMessage } from 'react-intl';

import MainLayout from 'components/presenters/layouts/main/MainLayout';
import NoContent from 'components/widgets/NoContent/NoContent';
import routes from 'routesPaths';

import GridUpdatingHook from '../components/GridUpdatingHook/GridUpdatingHook';
import { COMPONENT_NAME } from '../constants';

import { ContinueWatchingGridContainer } from './components/ContinueWatchingGridContainer';
import { useContinueWatchingGrid } from './hooks/useContinueWatchingGrid';

import styles from './ContinueWatchingGrid.module.scss';

function ContinueWatchingGrid() {
  const { settings, gridType, data, wrapperRef, notValidPageTitle, setForceUpdate } = useContinueWatchingGrid();
  const shouldShowNoContent = !settings || !data;

  if (shouldShowNoContent) {
    return (
      <MainLayout>
        <NoContent title={notValidPageTitle} />
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <GridUpdatingHook setForceUpdate={setForceUpdate} path={routes.continueWatchingGrid.path} />

      <div ref={wrapperRef} className={styles.wrapper}>
        <FormattedMessage
          defaultMessage={settings.title}
          id={`${COMPONENT_NAME}.title.${settings.title}`}
          tagName='h3'
        />
        <ContinueWatchingGridContainer data={data} type={gridType} settings={settings} />
      </div>
    </MainLayout>
  );
}

export default React.memo(ContinueWatchingGrid);
